import { render, staticRenderFns } from "./ButtonWrapper.vue?vue&type=template&id=24462ea5&scoped=true"
import script from "./ButtonWrapper.vue?vue&type=script&lang=js"
export * from "./ButtonWrapper.vue?vue&type=script&lang=js"
import style0 from "./ButtonWrapper.vue?vue&type=style&index=0&id=24462ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24462ea5",
  null
  
)

export default component.exports